utils.load_fonts = function() {
    WebFont.load({
        google: {
            families: ['Source Sans Pro:400,300,300italic,400italic,600,700']
        }
    });
};